import WorkspaceLayout from '../../components/navigation/WorkspaceLayout'

export default function DoctorLayout() {
  return <WorkspaceLayout role="doctor" />
}
